import React from 'react';
import { useAlertDispatcherState, useAlertsState } from '../Context/AlertProvider/AlertProvider';
import { removeAlert } from '../Context/AlertProvider/AlertProviderActions';
import { Alert } from 'antd';
import { duration, now } from 'moment';
import Countdown from 'react-countdown';
import { CountdownRendererFn } from 'react-countdown/dist/Countdown';
import {useLayoutState} from '../Context/LayoutProvider/LayoutProvider';

interface ViewProps {
    isToast?: boolean;
}

export const DiazarAlerts: React.FunctionComponent<ViewProps> = (props) => {
    const isToast = props.isToast || false;

    const alertsData = useAlertsState();
    const alertDispatch = useAlertDispatcherState();
    const {collapsed} = useLayoutState();

    const removeAlertById = React.useCallback((id: string) => {
        removeAlert(id, alertDispatch);
    }, [alertDispatch]);

    const checkFinisheds = React.useCallback(() => {
        alertsData.forEach(data => {
            const diff = duration(data.finish?.diff(now())).seconds();
            if (diff <= 0) {
                removeAlert(data.id, alertDispatch);
            }
        });
    }, [alertDispatch, alertsData]);

    const renderer = React.useCallback<CountdownRendererFn>((cd_props) => {
        if (cd_props.completed) {
            setTimeout(() => {
                checkFinisheds();
            }, 300);
            return <></>;
        } else {
            return <span>({cd_props.seconds})</span>;
        }
    }, [checkFinisheds]);

    const Alerts = React.useMemo(() => {
        return alertsData.map(data => {
            const title = (
                <span>
                    {data.title}{' '}<small><Countdown renderer={renderer} date={data.finish?.toDate()} /></small>.
                </span>
            );

            const body = (
                <span>
                    {data.body}{' '}<small><Countdown renderer={renderer} date={data.finish?.toDate()} /></small>
                </span>
            );

            const alertStyle = {
                marginBottom: 8,
                marginTop: 4
            };
            if (!isToast) {
                alertStyle['padding'] = 5;
            }

            return (
                <Alert
                    key={data.id}
                    message={ isToast ? title : undefined}
                    description={isToast ? data.body : body }
                    type={data.variant} // Ant Design soporta 'success', 'info', 'warning', 'error'
                    closable
                    showIcon
                    onClose={() => removeAlertById(data.id)}
                    style={alertStyle}
                    banner={!isToast}
                />
            );
        });
    }, [alertsData, isToast, removeAlertById, renderer]);

    const widthContent : string = React.useMemo(() => {
        if (isToast){
            return '400px';
        }else{
            if (collapsed){
                return 'calc(100% - 80px)';
            }else{
                return 'calc(100% - 300px)';
            }
        }
    } , [isToast, collapsed] );

    if (isToast) {
        return (
            <div style={{ position: 'fixed', top: 20, right: 20, width: widthContent, zIndex: 1000, textAlign:'left' }}>
                {Alerts}
            </div>
        );
    }

    return (
        <div style={{position: 'fixed', width:widthContent , zIndex: 1000, textAlign: 'left'}}>
            {Alerts}
        </div>
    );


};
